import { twMerge } from "tailwind-merge";
import { m } from "framer-motion";
import { useIsDark } from "@/context/ThemeContext";

export default function Process({
  Data,
  sectionHeight, // MANDATORY - to calculate the height of one data set
  sectionStyles,
  isThereTwoMediumCubes = false,
  enableHoverEffect = false,
  smallCubeStyles,
  mediumCubeStyles,
  secondmediumCubeStyles,
  largeCubeStyles,
}) {
  const heightPerOnePoint = (sectionHeight - 100) / Data.length;

  const isdark = useIsDark();

  return (
    <div
      className={twMerge(
        "flex w-full max-w-[2000px] rounded-[10px] py-[25px] md:py-[50px] mt-[50px] z-50",
        isdark ? "bg-[#0F0F0F]" : "bg-[#FFFFFF]",
        sectionStyles
      )}
    >
      <section className="hidden mobile:flex flex-col relative">
        <h1 className="font-alexandria font-bold text-[30px] md:text-[42px] lg:text-[62px] xl:text-[82px] 3xl:text-[92px] dark:text-[#ED92FF] text-[#9C00BB] uppercase ml-2 sm:ml-5 md:ml-10 xl:ml-15">
          process
        </h1>
        {/* small cube */}
        <img
          src="/assets/Cube.svg"
          alt="small cube"
          className={twMerge(
            "absolute top-[174px] xl:top-[274px] left-[-3px] w-[80px] h-[60px] xl:w-[120px] xl:h-[84px] rotate-180",
            smallCubeStyles
          )}
        />
        {/* medium cube */}
        <img
          src="/assets/Cube.svg"
          alt="medium cube"
          className={twMerge(
            "absolute top-[315px] left-[76px] xl:left-[176px] w-[120px] h-[84px] xl:w-[195px] xl:h-[137px] rotate-90",
            mediumCubeStyles
          )}
        />
        {/* second medium cube - if there's one */}
        {isThereTwoMediumCubes && (
          <img
            src="/assets/Cube.svg"
            alt="another cube"
            className={twMerge(
              "w-[120px] h-[84px] xl:w-[195px] xl:h-[137px] rotate-90",
              secondmediumCubeStyles
            )}
          />
        )}
        {/* large cube */}
        <img
          src="/assets/Cube.svg"
          alt="large cube"
          className={twMerge(
            "absolute top-[426px] left-0 w-[494px] h-[346px]",
            largeCubeStyles
          )}
        />
      </section>

      {/* Process data line */}
      {/* this process headline is only for small screens */}
      <section className="pl-3 pr-1 mobile:px-2 sm:px-5 md:px-10 xl:px-15 3xl:px-20 pt-2 xl:pt-5">
        <h1 className="block mobile:hidden font-alexandria font-bold text-[30px] dark:text-[#ED92FF] text-[#9C00BB] uppercase mb-2">
          Process
        </h1>
        {Data.map((point, index) => (
          <div key={index} className="flex gap-4 xl:gap-10">
            <div
              className="flex flex-col items-center text-[#121212] dark:text-[#FFFFFF]"
              style={{ height: `${heightPerOnePoint}px` }}
            >
              <m.div
                whileHover={
                  enableHoverEffect ? {  backgroundColor: isdark ? "#FF63FA" : "#FF1CF7" } : {}
                }
                transition={{ duration: 0.6, ease: "easeIn" }}
                className="flex items-center justify-center w-[32px] h-[32px] xl:w-[56px] xl:h-[55px] font-albertSans font-semibold text-[14px] xl:text-xl border-2 dark:border-[#FF63FA] border-[#FF1CF7] rounded-full tracking-[0.02em]"
              >
                {`0${index + 1}`}
              </m.div>

              {index !== Data.length - 1 && (
                <div className="w-[1px] dark:bg-[#FF63FA] bg-[#FF1CF7] flex-1"></div>
              )}
            </div>

            <div>
              <h1 className="font-manrope font-semibold text-[20px] md:text-[25px] xl:text-[30px] 3xl:text-[32px] 4xl:text-[35px] tracking-[0.02em]">
                {point.topic}
              </h1>
              <p className="font-manrope text-[#121212] dark:text-[#FFFFFF] font-medium text-[13px] sm:text-[14px] md:text-[16px] xl:text-[17px] 3xl:text-xl leading-[28px] tracking-[0.02em]">
                {point.description}
              </p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
